module.exports = __webpack_public_path__ + "static/hexowatch-logo-68f8375c7854fa576780a264fb703fd0.svg";